export const proMenuArr = [
    {
        name: 'DFAI沉浸式数字战场',
        childs: [
            {
                name: 'DFAI',
                href: 'parName=DFAI沉浸式数字战场&name=DFAI',
                mp4Arr: [],
            },
            // {
            //     name: '次世代数字太空大屏',
            //     href: 'parName=DFAI沉浸式数字战场&name=次世代数字太空大屏',
            //     mp4Arr: []
            // },
            // {
            //     name: '多维雷达态势可视化',
            //     href: 'parName=DFAI沉浸式数字战场&name=多维雷达态势可视化',
            //     mp4Arr: [],
            // },
            // {
            //     name: '通用雷达模拟器',
            //     href: 'parName=DFAI沉浸式数字战场&name=通用雷达模拟器',
            //     mp4Arr: [],
            // },
            // {
            //     name: '大倾角影像识别',
            //     href: 'parName=DFAI沉浸式数字战场&name=大倾角影像识别',
            //     mp4Arr: [],
            // }
        ],
    },
    {
        name: '流体模拟软件',
        childs: [
            {
                name: '航天三院流体模拟软件',
                href: 'parName=流体模拟软件&name=航天三院流体模拟软件',
                mp4Arr: [],
            },
        ],
    },
    {
        name: '融组态',
        childs: [
            // {
            //     name: '中国邮政寄递数字孪生平台',
            //     href: 'parName=融组态&name=中国邮政寄递数字孪生平台',
            //     mp4Arr: [],
            // },
            // {
            //     name: '壳牌精英店智能AR预览',
            //     href: 'parName=融组态&name=壳牌精英店智能AR预览',
            //     mp4Arr: [],
            // },
            // {
            //     name: '泰康中西医一体机',
            //     href: 'parName=融组态&name=泰康中西医一体机',
            //     mp4Arr: [],
            // },
            // {
            //     name: '联想UDCC',
            //     href: 'parName=融组态&name=联想UDCC',
            //     mp4Arr: [],
            // },
            // {
            //     name: '联想智会Pro',
            //     href: 'parName=融组态&name=联想智会Pro',
            //     mp4Arr: [],
            // },
            // {
            //     name: '联想智能引擎',
            //     href: 'parName=融组态&name=联想智能引擎',
            //     mp4Arr: [],
            // },
        ],
    },
    {
        name: '通用雷达模拟器',
        childs: [
            {
                name: '通用雷达模拟器',
                href: 'parName=DFAI沉浸式数字战场&name=通用雷达模拟器',
                mp4Arr: [],
            },
            // {
            //     name: '建筑专业',
            //     href: 'parName=通用雷达模拟器&name=建筑专业',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/BIM虚拟仿真.mp4',
            //             img: 'http://124.205.59.39/dfrcSite/bigImg/虚拟仿真.png',
            //             name: 'BIM虚拟仿真',
            //             header: 'BIM正向设计虚拟仿真教学系统',
            //             description: 'BIM 正向设计虚拟仿真认知与知识类课程BIM，利用 VR 技术，学习从方案设计-初步设计-施工图设计全流程设计理论知识与设计主要工作流程，掌握 BIM 设计规范要求，认知各个阶段不同设计精度的 BIM 模型，及 BIM 正向设计的先进行业应用与价值点，具备 BIM 协同正向设计的初步认知。'
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/定额虚拟仿真.mp4',
            //             img: 'http://124.205.59.39/dfrcSite/bigImg/虚拟仿真 2.png',
            //             name: '定额虚拟仿真',
            //             header: '定额原理与市场化计价虚拟仿真系统',
            //             description: '本仿真系统包含4D微课、仿真交互、实践应用、教学管理等相关教学内容。系统性的直观的让学生了解：定额概念、分类体系、定额的应用等相关的知识点，通过4D课堂教学管理帮助教师将课程内容更加直观的传递给学生，并通过随堂测验、考试中心等将学习形成完整的闭环。'
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/榫卯-mp4.mp4',
            //             img: 'http://124.205.59.39/dfrcSite/bigImg/榫卯.png',
            //             name: '榫卯',
            //             header: '传统建筑榫卯结构虚拟仿真实验',
            //             description: '榫卯，是中国传统建筑、家具及其它器械的主要结构方式，是在两个以及多个构件上采用凹凸部位相结合的一种连接方式。凸出部分叫榫（或叫榫头）；凹进部分叫卯（或叫榫眼、榫槽）。本项目通过学生复原现存较为完整的唐代寺庙-五台山佛光寺，使学生教学系统的了解各朝代斗拱及榫卯结构的仿真实验项目，同时通过对多个榫卯结构进行制作，让学生加深对榫卯结构的认识，系统中还提供各朝代斗拱及榫卯结构的示意图及相关介绍'
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/大跨度斜拉桥-mp4.mp4',
            //             img: 'http://124.205.59.39/dfrcSite/bigImg/大跨度斜拉桥.png',
            //             name: '大跨度斜拉桥',
            //             header: '大跨度桥梁抗震与减隔震性能虚拟多点振动台阵实验',
            //             description: '为有效解决大跨度桥梁结构抗震、减隔震性能多点振动台阵系统足尺试验或者缩尺试验的费力、耗时、成本高昂和无法在日常课堂教学中开展实验教学等问题，本项目基于“能实不虚、虚实结合”的原则，采用计算机虚拟实验技术开展大跨度桥梁抗震与减隔震性能虚拟振动台实验教学研究，并将其引入本科生《桥梁抗震与抗风设计》课堂教学环节，从而达到不断提高本科生的课堂教学效果和提升教学质量的目的。'
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/消防-mp4.mp4',
            //             img: 'http://124.205.59.39/dfrcSite/bigImg/消防.png',
            //             name: '消防',
            //             header: '',
            //             description: ''
            //         }
            //     ]
            // },
            // {
            //     name: '化工专业',
            //     href: 'parName=通用雷达模拟器&name=化工专业',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/土壤修复-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/土壤修复.png",
            //             name: "土壤修复",
            //         },
            //     ]
            // },
            // {
            //     name: '环境专业',
            //     href: 'parName=通用雷达模拟器&name=环境专业',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/石家庄中节能垃圾发电厂-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/石家庄中节能垃圾发电厂.png",
            //             name: "垃圾发电",
            //         },
            //     ]
            // },
            // {
            //     name: '自动化专业',
            //     href: 'parName=通用雷达模拟器&name=自动化专业',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/无人艇录频-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/无人艇录频.png",
            //             name: "无人艇控制",
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/动车-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/动车.png",
            //             name: "动车",
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/酿造视频1.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/酿造视频1.png",
            //             name: '酿造视频1',
            //             header: '面向酿造过程的复杂系统控制',
            //             description: '本虚仿实验系统模拟啤酒生产线实验装置，系统由过程控制生产线、运动控制生产线共16个工段分部组成，过程控制生产线包括制麦、糖化、过滤、发酵、熟化、杀菌、存储7个工段，运动控制生产线包括理瓶、清洗、灌装、打盖、金检、贴标、供箱、移载、立体库9个工段。各分部之间既有紧密的联系，又可相对独立运行。系统的结构设计具有开放性和扩展性，可以完成模拟生产线的控制系统设计，包括各分部的软硬件设计、调试，整体设计、调试，最终完成生产工艺的全过程。是“基于问题的学习、基于项目的学习、基于案例的学习的研究性学习方法”的实践。'
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/酿造视频2.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/酿造视频2.png",
            //             name: '酿造视频2',
            //             header: '面向酿造过程的复杂系统控制',
            //             description: '本虚仿实验系统模拟啤酒生产线实验装置，系统由过程控制生产线、运动控制生产线共16个工段分部组成，过程控制生产线包括制麦、糖化、过滤、发酵、熟化、杀菌、存储7个工段，运动控制生产线包括理瓶、清洗、灌装、打盖、金检、贴标、供箱、移载、立体库9个工段。各分部之间既有紧密的联系，又可相对独立运行。系统的结构设计具有开放性和扩展性，可以完成模拟生产线的控制系统设计，包括各分部的软硬件设计、调试，整体设计、调试，最终完成生产工艺的全过程。是“基于问题的学习、基于项目的学习、基于案例的学习的研究性学习方法”的实践。'
            //         }
            //     ]
            // },
            // {
            //     name: '财会金融专业',
            //     href: 'parName=通用雷达模拟器&name=财会金融专业',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/牡蛎审计.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/牡蛎.png",
            //             name: "牡蛎审计",
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/洪涝-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/洪涝.png",
            //             name: "洪涝车险仿真",
            //         }
            //     ],
            // },
            // {
            //     name: '生物专业',
            //     href: 'parName=通用雷达模拟器&name=生物专业',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/dna-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/dna.png",
            //             name: "dna",
            //         }
            //     ],
            // },
            // {
            //     name: '文科专业',
            //     href: 'parName=通用雷达模拟器&name=文科专业',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/司法-国际部分录屏.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/司法-国际部分.png",
            //             name: "司法-国际部分",
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/西班牙语.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/西班牙语.png",
            //             name: "西班牙语",
            //         }
            //     ],
            // }
        ],
    },
    {
        name: 'DFAI For Bussiness',
        childs: [
            // {
            //     name: '中海油',
            //     href: 'parName=DFAI For Bussiness&name=中海油',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/中海油培训-mp4.mp4',
            //             img: require("@img/中海油培训.png"),
            //             name: '中海油'
            //         }
            //     ]
            // }
        ],
    },
    {
        name: '智慧数字教育平台',
        childs: [
            // {
            //     name: '智慧园区',
            //     href: 'parName=智慧数字教育平台&name=智慧园区',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/长江水厂-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/长江水厂.png",
            //             name: '长江水厂'
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/长江水厂-2-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/长江水厂-2.png",
            //             name: '长江水厂-2'
            //         }
            //     ],
            // },
            // {
            //     name: '工业组态',
            //     href: 'parName=智慧工厂&name=工业组态',
            //     mp4Arr: [
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/佳力奇项目录屏.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/佳力奇.png",
            //             name: '佳力奇项目'
            //         },
            //         {
            //             src: 'http://124.205.59.39/dfrcSite/mp4/仓储-mp4.mp4',
            //             img: "http://124.205.59.39/dfrcSite/bigImg/仓储.png",
            //             name: '智慧仓储'
            //         },
            //         {
            //             text: true,
            //             img: require("@conImg/image1.png"),
            //             name: '工业组态'
            //         },
            //         {
            //             text: true,
            //             img: require("@conImg/image2.png"),
            //             name: '中电永昌'
            //         },
            //         {
            //             text: true,
            //             img: require("@conImg/image6.png"),
            //             name: '津西钢铁'
            //         },
            //         {
            //             text: true,
            //             img: require("@conImg/image10.png"),
            //             name: '科前生物'
            //         }
            //     ],
            // }
        ],
    },
];

export const proMenuArrNew = [
    {
        name: 'DFAI沉浸式数字战场',
        href: 'name=DFAI沉浸式数字战场',
        mp4Arr: [],
    },
    {
        name: '流体模拟软件',
        href: 'name=流体模拟软件',
        mp4Arr: [],
    },
    {
        name: '融组态',
        href: 'name=融组态',
        mp4Arr: [],
    },
    {
        name: '通用雷达模拟器',
        href: 'name=通用雷达模拟器',
        mp4Arr: [],
    },
    {
        name: 'DFAI For Bussiness',
        href: 'name=DFAI For Bussiness',
        mp4Arr: [],
    },
    {
        name: '智慧数字教育平台',
        href: 'name=智慧数字教育平台',
        mp4Arr: [],
    }
]